module.exports = global["zfrespond"] = require("-!/root/project/node_modules/babel-loader/lib/index.js??ref--7-0!./zfrespond_setup.js");